import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private baseApi = environment.baseApi + '/configuration';

  constructor(private http: HttpClient, private loginService: LoginService) { 

  }

  getCatalog(idCustomer: number) {
    return this.http.get<any>(`${this.baseApi}/${idCustomer}`).toPromise();
  }

  updateVisible(idCustomer: number, idStatus: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<Response>(`${this.baseApi}/${idCustomer}/${idStatus}`, { headers }).toPromise();
  }

  updateName(idCustomer: number, body: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<Response>(`${this.baseApi}/${idCustomer}`, body, { headers }).toPromise();
  }

}